import React from 'react';

// Filet de sécurité : si un composant plante (ex. DOM modifié par un agent externe),
// on affiche un message clair au lieu de démonter toute la page (écran blanc).
// Remplace proprement l'ancien monkeypatch removeChild/insertBefore.
export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    // Trace technique en console (utile pour le diagnostic).
    console.error('🛡️ ErrorBoundary a intercepté un plantage :', error, info?.componentStack);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          maxWidth: 480, margin: '3rem auto', padding: '2rem', textAlign: 'center',
          fontFamily: 'system-ui, sans-serif', border: '1px solid #e5e7eb', borderRadius: 12
        }}>
          <h2 style={{ fontSize: 20, fontWeight: 700, marginBottom: 12 }}>
            Un problème d'affichage est survenu
          </h2>
          <p style={{ color: '#4b5563', marginBottom: 20, lineHeight: 1.5 }}>
            Merci de recharger la page. Astuce : au moment de payer, saisissez votre carte
            <strong> manuellement</strong> plutôt que d'utiliser le remplissage automatique du navigateur.
          </p>
          <button
            onClick={() => window.location.reload()}
            style={{
              padding: '12px 24px', background: '#000', color: '#fff', border: 'none',
              borderRadius: 8, cursor: 'pointer', fontSize: 15, fontWeight: 600
            }}
          >
            Recharger la page
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
